import React from 'react';
import { useHistory } from 'react-router-dom';
import noWaves from 'assets/images/noWaves.png';
import { ApButtonMain } from '@alixpartners/ui-components';
import { Container, MainMessage } from './styles';

const NoAllocatedInitiatives = () => {
	const history = useHistory();
	return (
		<Container>
			<img src={noWaves} alt="no initiatives" width={370} />
			<MainMessage>Plan the execution of your initiatives</MainMessage>
			<ApButtonMain
				iconName="waves"
				onClick={() => {
					history.push('/waves/allocate');
				}}
			>
				allocate initiatives
			</ApButtonMain>
		</Container>
	);
};

export default NoAllocatedInitiatives;
